import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCurrencyExchange: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.4 7H21c.6 0 1 .4 1 1s-.4 1-1 1h-6.6l2.3 2.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-4-4c-.05-.05-.075-.1-.1-.15-.025-.05-.05-.1-.1-.15-.1-.3-.1-.5 0-.8 0-.1.1-.2.2-.3l4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L14.4 7zm-1.6 8.45c.025.05.05.1.1.15.1.3.1.5 0 .8 0 .1-.1.2-.2.3l-4 4c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L9.6 17H3c-.6 0-1-.4-1-1s.4-1 1-1h6.6l-2.3-2.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4 4c.05.05.075.1.1.15z',
    })
  )
}
